<style scoped lang="scss">
$width: 90%;

main {
  width: $width;
  margin-left: auto;
  margin-right: auto;
}

.status-table {
  li {
    transition: all 0.2s;
    // margin: 4px;
    padding: 4px 4px 0 4px;
    &:last-child {
      padding: 4px;
    }
  }
  .label {
    font-weight: bold;
  }
  .icon {
    transition: all 0.2s;
    font-weight: bold;
    color: #c939e1;
    font-size: 1rem;
  }
}
</style>

<template src="./home.html"></template>

<script>
// import './src/assets/theme.css';
import Store from '@/Store';

import {PROJECT_EXT} from '@/Const'
import swal from 'sweetalert'
// import musicListData from '@/assets/sample-music-list.json'
import musicListData from '~/static/sample/sample-music-list.json'

import pHeader from '@/components/Header';
import inputFile from '@/components/sub/InputFileField';
import actbutton from '@/components/sub/ActivationButton';
import musicList from '@/components/MusicList';

export default {
  name: 'home',

  components: {
    pHeader,
    inputFile,
    actbutton,
    musicList,
  },

  data () {
    return {
      state: Store.state,
      testerAudio: document.createElement('video'),
      musicListData: musicListData, // temp
    }
  },

  computed: {
    musicStatusClassObj () {
      return {
        't-moon--dark': true,
        'isActive': this.state.currentMusic,
      }
    },
    projectStatusClassObj () {
      return {
        't-moon--dark': true,
        'isActive': this.state.currentProject,
      }
    },
    isSimRunnable () {
      // return (this.state.currentMusic != null) && (this.state.currentProject != null);
      return (this.state.currentMusic != null) && (this.state.currentProject != null);
    }
  },

  // created () {},

  mounted () {
    // キー操作設定: ondestroyでremoveする
    document.addEventListener('keydown', (e)=> {
      let kc = e.keyCode;
      // f(70) or Tenkey *(106) or \|
      if (e.shiftKey && e.ctrlKey && kc === 70) {
        e.preventDefault();
        this._testMethod();
      }
    }, false);
  },

  methods: {
    _testMethod () {
      // run sample
      this.$pxbSim.run('./static/sample/GGAM/music.mp3', './static/sample/GGAM/project.pxbp')
    },

    uploadFile (evt) {
      // console.log(evt)

      if (evt.dataTransfer != null) {
        // by DnD
        var files = evt.dataTransfer.files;
      } else if (evt.target != null) {
        // by file selection
        var files = evt.target.files;
      } else {
        return false;
      }

      for (var i = 0, file; file = files[i]; i++) {
        const reader = new FileReader();

        if (file.type && /audio/.test(file.type)) {
          // Audio file
          const name = file.name;
          if (this.testerAudio.canPlayType(file.type) === "") {
            swal('Unsupported audio type', '未サポートの音源形式です', "error");
            continue;
          }
          reader.onload = function(e) {
            var dataURL = e.target.result;
            // console.log(dataURL)
            Store.setMusicAction(dataURL, name);
          };
          reader.readAsDataURL(file);
        } else if (file.name.indexOf(`.${PROJECT_EXT}`) != -1) {
          // beatmap
          var name = file.name;
          console.log('project file', file)
          reader.onload = function(e) {
            var rawData = e.target.result;
            var currentProject = JSON.parse(rawData);
            Store.setProjectAction(currentProject, name);
          };
          reader.readAsText(file);
        // } else if (file.type && /image/.test(file.type)) {
        //   // image
        //   console.log('image')
        } else {
          swal(`Audio file or project (.${PROJECT_EXT}) file only.`, "オーディオファイルかプロジェクトファイル（.pxbp）を選んで下さい", "error")
        }

        reader.onerror = function(err) {
          swal(err, "エラー", "error")
          console.error(err)
        }
        // reader.onload = (function(theFile) {
        //   return function(e) {
        //     var dataURL = e.target.result;
        //   };
        // })(f);
      }
    },

    onPushPlay (e) {
      if (this.state.currentMusic == null || this.state.currentProject == null) {
        swal("Music or Project file is not set!", "音源ファイルとプロジェクトファイルをセットして下さい", "error");
        return;
      }
      this.$pxbSim.run(this.state.currentMusic, this.state.currentProject);
    },

    onClickMusicJacket (musicSrc, projectSrc) {
      this.$pxbSim.run(musicSrc, projectSrc);
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Home/Home.vue